module.exports = __webpack_public_path__ + "static/media/country_nc.496077df.webp";